<script setup>
import { computed } from 'vue';
import { getFriendlyFileSize } from '@/utils';

import { uploads } from '@/services/upload';
import { FileType, UploadState } from '@/enums';

import Progress from './Progress.vue';

const props = defineProps({
    file: {
        type: Object,
        required: true,
    },
});

const upload =  computed(() => props.file.__client?.upload_id ? uploads[props.file.__client.upload_id] : null);
</script>

<template>
    <div class="h-40 w-40 rounded-md shrink-0 border border-white-foreground/20 flex items-center justify-center relative bg-[#121212]">
        <img v-if="file.type == 1" :src="file.url" class="h-full w-full object-contain" />
        <video v-else :src="file.url" class="h-full w-full object-cover" />

        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <template v-if="!upload || upload.state == UploadState.PENDING || upload.state == UploadState.COMPLETED">
                <button class="bg-[#000000]/50 text-[#ffffff] rounded-full p-1" v-if="file.type == FileType.VIDEO" type="button" aria-label="play video">
                    <icon-play class="size-6" />
                </button>
            </template>
            <Progress v-else :upload="upload" />
        </div>

        <div class="absolute bottom-0 bg-[#121212]/60 text-[#f2f2f2] w-full h-10 rounded-b-md p-0.5">
            <div class="text-xs truncate">{{ file.original_name ?? file.name }}</div>
            <div class="text-2xs">{{ getFriendlyFileSize(file.size) }}</div>
        </div>
    </div>
</template>
